import { z } from 'zod/v4';

import { CommonSearchParamsSchema } from '@/shared/utils/schemas';

const ActionStatusSchema = z.enum([
  'REQUESTED',
  'APPLIED',
  'REMOVE_REQUESTED',
  'REMOVED',
]);
export type ActionStatus = z.infer<typeof ActionStatusSchema>;

const ActionParamsSchema = z.object({
  action: z
    .array(ActionStatusSchema)
    .max(4)
    .refine((arr) => new Set(arr).size === arr.length)
    .optional()
    .catch(undefined),
});

export type ActionStatuses = z.infer<typeof ActionParamsSchema>['action'];

export const ChangeLogsParamsSchema = CommonSearchParamsSchema.extend({
  ordering: z.enum(['created_at']).optional().catch(undefined),
  ...ActionParamsSchema.shape,
});

export type ChangeLogsParams = z.infer<typeof ChangeLogsParamsSchema>;
